import linkifyHtml from "linkifyjs/html";
import Strings from "src/shared/Strings";
import dateTimeService from "src/shared/date-time-service";
import moment from "moment";
import { uniq } from "lodash";
const LEVEL_ICON_NAMES = {
    ERROR: "times-circle",
    WARN: "exclamation-triangle",
    INFO: "info-square",
};
class UserNotification {
    constructor(notificationResponse) {
        Object.assign(this, notificationResponse);
    }
    getDisplayName() {
        return Strings.capitalize(this.name);
    }
    getLevelIconName() {
        return LEVEL_ICON_NAMES[this.level];
    }
    getLevelClassIdentifier() {
        return (this.level || "").toLowerCase();
    }
    getDisplayLevel() {
        return Strings.capitalize(this.level);
    }
    getMessageHtml() {
        return linkifyHtml(this.message, {
            target: {
                url: "_blank",
            },
        });
    }
    getDateFormatted() {
        return dateTimeService.formatToDateTime(this.event_time);
    }
    getReferenceTagSet() {
        return uniq([this.name].concat(this.tags));
    }
    wasSnoozed() {
        return Boolean(this.snooze_id);
    }
    isUnread(notificationCursor) {
        if (notificationCursor === null) {
            return false;
        }
        const lastReadEventTime = moment(notificationCursor.last_read_event_time);
        const eventTime = moment(this.event_time);
        return lastReadEventTime.isBefore(eventTime) && !this.wasSnoozed();
    }
}
export default UserNotification;
